export default function () {
  // 个人 客户基本信息
  const personalBasicInfoList = [
    { key: 'id', name: '客户ID' },
    { key: 'source', name: '客户来源' },
    { key: 'customerName', name: '客户名称' },
    { key: 'customerTel', name: '手机号' },
    { key: 'tagList', name: '客户标签' },
    { key: 'ethnicity', name: '民族' },
    { key: 'registeredResidence', name: '户籍地址' },
    { key: 'issuanceAuthority', name: '签发机关' },
    { key: 'address', name: '居住地址' },
    { key: 'remarks', name: '备注' },
  ]

  // 个人 支付信息
  const personalPayList = [
    { key: 'bankPic', name: '银行卡照片', alone: true },
    { key: 'accountName', name: '户名' },
    { key: 'accountNo', name: '银行账号' },
    { key: 'bankName', name: '开户行' },
  ]

  return {
    personalBasicInfoList,
    personalPayList,
  }
}
